import getApiClient from "@/plugins/api-client";

export default {
    loadJobs() {
        const self = this,
              api = getApiClient(self.$store)

        api.get('jobs/wallet')
            .then(result => {
                self.jobs = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    }
}
